/**
 * DevExtreme (esm/ui/collection/ui.collection_widget.async.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidget from "../../__internal/ui/collection/m_collection_widget.async";
export default CollectionWidget;
